import React, { Component } from 'react';
import classNames from 'classnames';

class SelectField extends Component {
  constructor(props) {
    super(props)
  }
  
  render() {
    const {input, type, disabled, labelOption, meta: { touched, error }, placeholder, label, options } = this.props;
    return (
      <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
          <select {...input} disabled={disabled} style={{height: '35px'}} className="create-dialog-form__control" >
            {labelOption && <option value="">{labelOption || ''}</option>}
            {!labelOption && <option value=""></option>}
            {options.map(option => <option key={'option-' + option.value} value={option.value}>{option.title}</option>)}
          </select>
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
      </div>
    );
  }
}

export default SelectField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/SelectField.jsx